import React, { useEffect, useRef, useState } from "react";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import toast, { Toaster } from "react-hot-toast";

function SquenceGame(props) {
  const [currentItemArray, setCurrentItemArray] = useState([]);
  const [sequenceArray, setSequenceArray] = useState([]);
  const [userSequenceArray, setUserSequenceArray] = useState([]);
  const [grid, setGrid] = useState([]);
  const [count, setCount] = useState(0);
  const [correct, setCorrect] = useState(true);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [hideImageNum, setHideImageNum] = useState(0);
  const [runSeqNum, setRunSeqNum] = useState(0);
  const [id, setID] = useState(-1);
  const [number, setNumber] = useState(9);
  const [gameComplete, setGameComplete] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [sequenceFlag, setSequenceFlag] = useState(false);
  const [clickable, setClickable] = useState(false);
  const [play, setPlay] = useState(false);
  const [runSeqTrigger, setRunSeqTrigger] = useState(false);
  const [hideImageTrigger, setHideImageTrigger] = useState(false);
  const imageRef = useRef([]);
  const buttonRef = useRef([]);
  const [imageHeight, setImageHeight] = useState(64);
  const [imageWidth, setImageWidth] = useState(64);

  const identity = (i) => {
    setID(i);
  };

  useEffect(() => {
    if (id !== -1) {
      if (clickable === true && count + 1 === sequenceArray.length) {
        setUserSequenceArray((prevArray) => [...prevArray, id]);
        imageRef[id].src = currentItemArray[0].image;
      } else {
        if (count + 1 !== sequenceArray.length) {
          toast(
            "Please select the Start Level button to see the next sequence.",
            {
              duration: 3000,
              position: "right",
            }
          );
          for (let id = 0; id < userSequenceArray.length; id++) {
            imageRef[userSequenceArray[id]].src = currentItemArray[1].image;
            buttonRef[userSequenceArray[id]].style.backgroundColor = "#fff";
            setTimeout(() => {
              imageRef[userSequenceArray[id]].src = currentItemArray[0].image;
              buttonRef[userSequenceArray[id]].style.backgroundColor = "red";
            }, 250);
            setTimeout(() => {
              imageRef[userSequenceArray[id]].src = currentItemArray[1].image;
              buttonRef[userSequenceArray[id]].style.backgroundColor = "#fff";
            }, 500);
            setTimeout(() => {
              imageRef[userSequenceArray[id]].src = currentItemArray[0].image;
              buttonRef[userSequenceArray[id]].style.backgroundColor = "red";
            }, 750);
            setTimeout(() => {
              imageRef[userSequenceArray[id]].src = currentItemArray[1].image;
              buttonRef[userSequenceArray[id]].style.backgroundColor = "#fff";
            }, 1000);
          }
        } else {
          if (clickable !== true) {
            toast("Please wait until the sequence has finished.", {
              duration: 3000,
              position: "right",
            });
          }
        }
      }
      setID(-1);
    }
  }, [id]);

  useEffect(() => {
    props.setIncorrectCount(incorrectCount);
  }, [incorrectCount]);

  const handleGetItems = async () => {
    const response = await makeGetRequest(
      urls.getIcons + "?active=True&category=2",
      "",
      true
    );
    setCurrentItemArray(response.data);
  };

  useEffect(() => {
    if (window.innerHeight > 1000 && window.innerWidth > 1000) {
      setImageHeight(256);
      setImageWidth(256);
    }
    handleGetItems();
  }, []);

  useEffect(() => {
    createGrid();
  }, [currentItemArray]);

  const createGrid = () => {
    if (currentItemArray.length === 2) {
      let newGridComp = "";
      let addAllGrids = [];
      for (let i = 0; i < number; i++) {
        newGridComp = (
          <Col style={{ textAlign: "center" }} key={Math.random()}>
            <Button
              onClick={() => identity(i)}
              key={i}
              ref={(ref) => (buttonRef[i] = ref)}
              style={{
                width: imageWidth + 40,
                margin: "12px",
                height: imageHeight + 20,
                backgroundColor: "#fff",
                border: "",
                opacity: 1,
              }}
            >
              <img
                src={currentItemArray[1].image}
                ref={(ref) => (imageRef[i] = ref)}
                style={{
                  width: imageWidth,
                  height: imageHeight,
                  opacity: 1,
                }}
              ></img>
            </Button>
          </Col>
        );
        addAllGrids.push(newGridComp);
      }
      setGrid(addAllGrids);
    }
  };

  const createSequence = () => {
    let newSequenceArray = Math.floor(Math.random() * number);
    do {
      newSequenceArray = Math.floor(Math.random() * number);
    } while (sequenceArray.findIndex((id) => newSequenceArray === id) !== -1);
    setSequenceArray((prevArray) => [...prevArray, newSequenceArray]);
    setCorrect(false);
    setPlay(true);
  };

  const sequence = () => {
    if (count + 1 === sequenceArray.length) {
      let arrayTest = userSequenceArray.map((UA, x) => {
        return UA === sequenceArray[x];
      });
      let correct = false;
      if (arrayTest.includes(false)) {
        setUserSequenceArray([]);
        for (let i = 0; i < userSequenceArray.length; i++) {
          imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
          buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[0].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "red";
          }, 250);
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
          }, 500);
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[0].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "red";
          }, 750);
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
          }, 1000);
        }
        toast(
          "Sorry the order was incorrect. Please try again. If you need help use the yellow hint button.",
          {
            duration: 3000,
            position: "right",
          }
        );
        setIncorrectCount((prevCount) => prevCount + 1);
      } else {
        correct = true;
      }
      if (
        correct === true &&
        userSequenceArray.length === sequenceArray.length
      ) {
        setUserSequenceArray([]);
        for (let i = 0; i < userSequenceArray.length; i++) {
          imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
          buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[0].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "green";
          }, 250);
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
          }, 500);
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[0].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "green";
          }, 750);
          setTimeout(() => {
            imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
            buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
          }, 1000);
        }
        toast(
          "That was the correct sequence! Please press Start Level button to proceed to the next level.",
          {
            duration: 3000,
            position: "right",
          }
        );
        setClickable(false);
        setCorrect(true);
        setCount((prevCount) => prevCount + 1);
      }
    } else {
      toast("Please select the Start Level button to see the next sequence.", {
        duration: 3000,
        position: "right",
      });
      for (let i = 0; i < userSequenceArray.length; i++) {
        imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
        buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
        setTimeout(() => {
          imageRef[userSequenceArray[i]].src = currentItemArray[0].image;
          buttonRef[userSequenceArray[i]].style.backgroundColor = "red";
        }, 250);
        setTimeout(() => {
          imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
          buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
        }, 500);
        setTimeout(() => {
          imageRef[userSequenceArray[i]].src = currentItemArray[0].image;
          buttonRef[userSequenceArray[i]].style.backgroundColor = "red";
        }, 750);
        setTimeout(() => {
          imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
          buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
        }, 1000);
      }
    }
  };

  useEffect(() => {
    if (sequenceArray.length > 0) {
      if (userSequenceArray.length === sequenceArray.length) {
        sequence();
      }
      if (
        userSequenceArray.length < sequenceArray.length &&
        userSequenceArray.length !== 0
      ) {
        toast(
          "You've selected " +
            userSequenceArray.length +
            " of " +
            sequenceArray.length +
            ".",
          {
            duration: 3000,
            position: "right",
          }
        );
      }
    }
  }, [userSequenceArray]);

  useEffect(() => {
    if (correct === true) {
    }
  }, [correct]);

  let i = 0;

  const runSequenceLit = () => {
    setClickable(false);
    setTimeout(() => {
      setRunSeqTrigger(true);
    }, 1000);
  };

  useEffect(() => {
    if (runSeqTrigger === true) {
      setRunSeqTrigger(false);
      setHideImageNum(runSeqNum);
      imageRef[sequenceArray[runSeqNum]].src = currentItemArray[0].image;
      setTimeout(() => {
        setHideImageTrigger(true);
      }, 1000);
      setRunSeqNum((runSeqNum) => runSeqNum + 1);
      if (runSeqNum + 1 < sequenceArray.length) {
        runSequenceLit();
      } else {
        setRunSeqNum(0);
        setClickable(true);
      }
    }
  }, [runSeqTrigger]);

  useEffect(() => {
    if (hideImageTrigger === true) {
      imageRef[sequenceArray[hideImageNum]].src = currentItemArray[1].image;
    }
    setHideImageTrigger(false);
  }, [hideImageTrigger]);

  useEffect(() => {
    if (count === 10) {
      setGameComplete(true);
    }
    props.setCount(count);
  }, [count]);

  useEffect(() => {
    if (sequenceArray.length > 0) {
      for (let i = 0; i < userSequenceArray.length; i++) {
        imageRef[userSequenceArray[i]].src = currentItemArray[1].image;
        buttonRef[userSequenceArray[i]].style.backgroundColor = "#fff";
      }
      setUserSequenceArray([]);
      runSequenceLit();
    }
  }, [sequenceArray, sequenceFlag]);

  let stackedButtons = [];

  return (
    <>
      {play && (
        <Row>
          {grid.map((buttons, x) => {
            if (stackedButtons.length === 3) {
              stackedButtons = [];
            }
            stackedButtons.push(buttons);
            if (x % 3 === 0) {
              return <Row>{stackedButtons}</Row>;
            }
          })}
        </Row>
      )}
      {!correct ? (
        <Button
          variant="warning"
          onClick={() => setSequenceFlag(!sequenceFlag)}
        >
          Hint
        </Button>
      ) : (
        <Row style={{ marginTop: "25px" }}>
          <Button onClick={() => createSequence()}>
            Start Level {count + 1}
          </Button>
        </Row>
      )}
    </>
  );
}

export default SquenceGame;
